export default __webpack_public_path__ + "793bf31e721ccfa3836188461f86c5f6.png";